var render = function render() {
  var _vm$$parent;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container select-none",
    class: _vm.open && 'active',
    attrs: {
      "id": "devmenu"
    }
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', [_vm._v("🔧")])]), _vm._v(" "), _vm.$parent.isDemo ? _c('span', {
    staticClass: "ml-16 opacity-50 pointer-events-none"
  }, [_vm._v("Demo-mode")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fast-slide-up-fade",
      "mode": "out-in"
    }
  }, [_vm.open && !_vm.showPurchaseMenu ? _c('div', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "flex justify-between w-full mb-6 text-lg"
  }, [_vm._v("\n\t\t\t\tDev menu\n\t\t\t\t"), _c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "https://emoji.slack-edge.com/TBNJLMD9S/pug/20e20b28b9f78871.gif",
      "alt": ""
    },
    on: {
      "click": _vm.woof
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "my-1 text-sm font-semibold tracking-widest uppercase opacity-50"
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "space-y-1"
  }, [_c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.planSubmitted,
      expression: "$parent.$data.planSubmitted"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.planSubmitted) ? _vm._i(_vm.$parent.$data.planSubmitted, null) > -1 : _vm.$parent.$data.planSubmitted
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.planSubmitted,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "planSubmitted", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "planSubmitted", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "planSubmitted", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tPlan selected\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_vm._v(_vm._s(_vm.$parent.encodedCycle || '?') + "." + _vm._s(_vm.$parent.encodedPlan || '?'))])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.conditionalAuthEnabled,
      expression: "$parent.$data.conditionalAuthEnabled"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.conditionalAuthEnabled) ? _vm._i(_vm.$parent.$data.conditionalAuthEnabled, null) > -1 : _vm.$parent.$data.conditionalAuthEnabled
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.conditionalAuthEnabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "conditionalAuthEnabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "conditionalAuthEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "conditionalAuthEnabled", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("FCA Conditional Auth enabled")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.nextDayPayment,
      expression: "nextDayPayment"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.nextDayPayment) ? _vm._i(_vm.nextDayPayment, null) > -1 : _vm.nextDayPayment
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.nextDayPayment,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.nextDayPayment = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.nextDayPayment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.nextDayPayment = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("Next day payment option")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.formSubmitted,
      expression: "$parent.$data.formSubmitted"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.formSubmitted) ? _vm._i(_vm.$parent.$data.formSubmitted, null) > -1 : _vm.$parent.$data.formSubmitted
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.formSubmitted,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "formSubmitted", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "formSubmitted", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "formSubmitted", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("Form submitted")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": _vm.$parent.plaidReady
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tPlaid ready\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base opacity-50"
  }, [_vm._v(_vm._s(_vm.cd(_vm.$parent.plaidRemoteReady, 'server-side ok', 'server-side not ready')))]), _vm._v(" "), _c('span', {
    staticClass: "text-base underline opacity-50 cursor-pointer",
    on: {
      "click": _vm.clearPlaid
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": _vm.$parent.decisionReady
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tDecision ready\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base underline opacity-50 cursor-pointer",
    on: {
      "click": _vm.togglePolling
    }
  }, [_vm._v(_vm._s(_vm.cd(_vm.$parent.$data.decisionPolling, 'polling: on', 'polling: off')))]), _vm._v(" "), _c('span', {
    staticClass: "text-base underline opacity-50 cursor-pointer",
    on: {
      "click": _vm.clearDecision
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.billingConfirmed,
      expression: "$parent.$data.billingConfirmed"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.billingConfirmed) ? _vm._i(_vm.$parent.$data.billingConfirmed, null) > -1 : _vm.$parent.$data.billingConfirmed
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.billingConfirmed,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "billingConfirmed", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "billingConfirmed", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "billingConfirmed", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("Billing confirmed")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.kycSubmitted,
      expression: "$parent.$data.kycSubmitted"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.kycSubmitted) ? _vm._i(_vm.$parent.$data.kycSubmitted, null) > -1 : _vm.$parent.$data.kycSubmitted
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.kycSubmitted,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "kycSubmitted", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "kycSubmitted", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "kycSubmitted", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tKYC submitted on backend (done fraud check or apto kyc)\n\t\t\t\t\t")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.canRetryPlaid,
      expression: "$parent.$data.canRetryPlaid"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.canRetryPlaid) ? _vm._i(_vm.$parent.$data.canRetryPlaid, null) > -1 : _vm.$parent.$data.canRetryPlaid
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.canRetryPlaid,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "canRetryPlaid", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "canRetryPlaid", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "canRetryPlaid", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("Can retry Plaid (frontend only)")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.promptManualReview,
      expression: "$parent.$data.promptManualReview"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.promptManualReview) ? _vm._i(_vm.$parent.$data.promptManualReview, null) > -1 : _vm.$parent.$data.promptManualReview
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.promptManualReview,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "promptManualReview", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "promptManualReview", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "promptManualReview", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("Prompt manual review")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.partialData,
      expression: "$parent.$data.partialData"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.partialData) ? _vm._i(_vm.$parent.$data.partialData, null) > -1 : _vm.$parent.$data.partialData
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.partialData,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "partialData", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "partialData", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "partialData", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("No 30d history / partial data")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.plaidInsufficient,
      expression: "plaidInsufficient"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plaidInsufficient) ? _vm._i(_vm.plaidInsufficient, null) > -1 : _vm.plaidInsufficient
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.plaidInsufficient,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plaidInsufficient = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.plaidInsufficient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.plaidInsufficient = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("Plaid is insufficient")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.ecbsvInvalid,
      expression: "$parent.$data.ecbsvInvalid"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.ecbsvInvalid) ? _vm._i(_vm.$parent.$data.ecbsvInvalid, null) > -1 : _vm.$parent.$data.ecbsvInvalid
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.ecbsvInvalid,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "ecbsvInvalid", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "ecbsvInvalid", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "ecbsvInvalid", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("eCBSV came back invalid")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isCorporate
    },
    on: {
      "click": _vm.setCorporate
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("Corporate bank account")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.$parent.$data.applicationQueued
    },
    on: {
      "click": _vm.setApplicationQueued
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("Application queued")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    staticClass: "w-auto",
    attrs: {
      "disabled": _vm.personaBypassed,
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.personaBypassed
    },
    on: {
      "click": _vm.setPersonaBypass
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("Persona complete")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.promptECBSV,
      expression: "$parent.$data.promptECBSV"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.promptECBSV) ? _vm._i(_vm.$parent.$data.promptECBSV, null) > -1 : _vm.$parent.$data.promptECBSV
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.promptECBSV,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "promptECBSV", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "promptECBSV", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "promptECBSV", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("Prompt eCBSV")])])]), _vm._v(" "), _c('p', {
    staticClass: "my-1 mt-6 text-sm font-semibold tracking-widest uppercase opacity-50"
  }, [_vm._v("\n\t\t\t\tOverrides\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "space-y-2"
  }, [_c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('p', {
    staticClass: "flex justify-between w-full text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tFunnel stage\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.stageOverride,
      expression: "$parent.$data.stageOverride"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.$parent.$data, "stageOverride", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("No override")]), _vm._v(" "), _vm._l(Object.values((_vm$$parent = _vm.$parent) === null || _vm$$parent === void 0 ? void 0 : _vm$$parent._STAGE_enum), function (key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))]);
  })], 2)])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('p', {
    staticClass: "flex justify-between w-full text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tKYC status\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.kycStatus,
      expression: "$parent.$data.kycStatus"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.$parent.$data, "kycStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Not submitted")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PASSED"
    }
  }, [_vm._v("PASSED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "REJECTED"
    }
  }, [_vm._v("REJECTED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UNDER_REVIEW"
    }
  }, [_vm._v("UNDER_REVIEW")])])])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('p', {
    staticClass: "flex justify-between w-full text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tRisk Engine Decision\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_vm.$parent.$data.decisionStatus ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.decisionStatus,
      expression: "$parent.$data.decisionStatus"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.$parent.$data, "decisionStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rejected"
    }
  }, [_vm._v("Rejected")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "error"
    }
  }, [_vm._v("Error")])]) : _c('span', [_vm._v("Not ready")])])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('p', {
    staticClass: "flex justify-between w-full text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tClassification\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-sm text-right opacity-50"
  }, [_vm.$parent.$data.memberProfile && _vm.$parent.$data.memberProfile.externalCategory ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$parent.$data.memberProfile.externalCategory) + "\n\t\t\t\t\t\t\t")]) : _c('span', [_vm._v("none")])])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('p', {
    staticClass: "flex justify-between w-full text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tForced fraud result\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.forcedFraudResult,
      expression: "$parent.$data.forcedFraudResult"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.$parent.$data, "forcedFraudResult", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rejected"
    }
  }, [_vm._v("rejected")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "verify_docs"
    }
  }, [_vm._v("verify_docs")])])])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('p', {
    staticClass: "flex justify-between w-full text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tForce application-queued error for signup\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.forcedApplicationQueuedError,
      expression: "$parent.$data.forcedApplicationQueuedError"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.forcedApplicationQueuedError) ? _vm._i(_vm.$parent.$data.forcedApplicationQueuedError, null) > -1 : _vm.$parent.$data.forcedApplicationQueuedError
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.forcedApplicationQueuedError,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "forcedApplicationQueuedError", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "forcedApplicationQueuedError", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "forcedApplicationQueuedError", $$c);
        }
      }
    }
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('p', {
    staticClass: "flex justify-between w-full text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tForced eCBSV result\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.forcedECBSVResult,
      expression: "$parent.$data.forcedECBSVResult"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.$parent.$data, "forcedECBSVResult", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "deceased"
    }
  }, [_vm._v("deceased")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rejected"
    }
  }, [_vm._v("rejected")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "error"
    }
  }, [_vm._v("error")])])])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center text-lg"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.processing,
      expression: "$parent.$data.processing"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.processing) ? _vm._i(_vm.$parent.$data.processing, null) > -1 : _vm.$parent.$data.processing
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.$parent.$data.processing,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.$parent.$data, "processing", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.$parent.$data, "processing", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.$parent.$data, "processing", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tLoading indicator\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$parent.$data.processingReason,
      expression: "$parent.$data.processingReason"
    }],
    staticClass: "p-0 pb-1 m-0 text-base",
    attrs: {
      "type": "text",
      "placeholder": "type label text here"
    },
    domProps: {
      "value": _vm.$parent.$data.processingReason
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.$parent.$data, "processingReason", $event.target.value);
      }
    }
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center text-lg"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.errorContext,
      expression: "errorContext"
    }],
    staticClass: "w-auto",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.errorContext) ? _vm._i(_vm.errorContext, null) > -1 : _vm.errorContext
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.errorContext,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.errorContext = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.errorContext = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.errorContext = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tError\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.errorContextString,
      expression: "errorContextString"
    }],
    staticClass: "p-0 pb-1 m-0 text-base",
    class: {
      'opacity-50': _vm.errorContext
    },
    attrs: {
      "disabled": _vm.errorContext,
      "type": "text",
      "placeholder": "error context"
    },
    domProps: {
      "value": _vm.errorContextString
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.errorContextString = $event.target.value;
      }
    }
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center text-lg"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.warningContext,
      expression: "warningContext"
    }],
    staticClass: "w-auto",
    class: [!_vm.warningContextString && 'opacity-25 cursor-not-allowed'],
    attrs: {
      "disabled": !_vm.warningContextString,
      "type": "checkbox",
      "title": !_vm.warningContextString && 'warning context is required'
    },
    domProps: {
      "checked": Array.isArray(_vm.warningContext) ? _vm._i(_vm.warningContext, null) > -1 : _vm.warningContext
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.warningContext,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.warningContext = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.warningContext = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.warningContext = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full ml-2 text-lg"
  }, [_vm._v("\n\t\t\t\t\t\tWarning\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "text-base text-right opacity-50"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.warningContextString,
      expression: "warningContextString"
    }],
    staticClass: "p-0 pb-1 m-0 text-base",
    class: {
      'opacity-50': _vm.warningContext
    },
    attrs: {
      "disabled": _vm.warningContext,
      "type": "text",
      "placeholder": "warning context"
    },
    domProps: {
      "value": _vm.warningContextString
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.warningContextString = $event.target.value;
      }
    }
  })])])])]), _vm._v(" "), _vm.isMobile ? _c('div', {
    staticClass: "flex flex-row justify-between w-full my-4 mt-2"
  }, [_c('p', {
    staticClass: "text-sm font-semibold tracking-widest uppercase opacity-50"
  }, [_vm._v("Active screen")]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-base text-green-600"
  }, [_vm._v(_vm._s(_vm.$parent.currentStage))])]) : _c('div', {
    staticClass: "flex flex-row justify-start w-full my-2 mt-6"
  }, [_c('p', {
    staticClass: "text-sm font-semibold tracking-widest uppercase opacity-50"
  }, [_vm._v("Active screens")]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-base underline opacity-25 cursor-pointer",
    on: {
      "click": _vm.toggleActives
    }
  }, [_vm._v(_vm._s(!_vm.showActives ? 'Show' : 'Hide'))])]), _vm._v(" "), _vm.showActives && !_vm.isMobile ? _c('div', {
    staticClass: "max-w-lg mx-auto text-gray-600 active-screens"
  }, [_c('p', [_c('span', {
    class: _vm.cd(_vm.$parent.showLockStage)
  }, [_vm._v("LOCKED")]), _vm._v(" -\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.lock)
  }, [_vm._v("lock")])]), _vm._v(" "), _c('p', [_c('span', {
    class: _vm.cd(_vm.$parent.decisionFinalRejected)
  }, [_vm._v("REJECT")]), _vm._v(" -\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.decisionFinal)
  }, [_vm._v("decisionFinal")]), _vm._v(" and\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.decisionStatus === 'rejected')
  }, [_vm._v("\n\t\t\t\t\t\tdecision = rejected\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\tand\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.kycSubmitted)
  }, [_vm._v("kycSubmitted")])]), _vm._v(" "), _c('p', [_c('span', {
    class: _vm.cd(_vm.$parent.showPlanStage)
  }, [_vm._v("D0 QUESTIONS")]), _vm._v(" - not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.d0Answered)
  }, [_vm._v("d0Answered")])]), _vm._v(" "), _c('p', [_c('span', {
    class: _vm.cd(_vm.$parent.showPlanStage)
  }, [_vm._v("PLAN")]), _vm._v(" - not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.planSubmitted)
  }, [_vm._v("planSubmitted")]), _vm._v(" or no\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.plan)
  }, [_vm._v("plan")])]), _vm._v(" "), _c('p', [_c('span', {
    class: _vm.cd(_vm.$parent.showPlaidStage)
  }, [_vm._v("PLAID")]), _vm._v(" - not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.plaidReady)
  }, [_vm._v("plaidReady")]), _vm._v(" and not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.plaidRemoteReady)
  }, [_vm._v("plaidRemoteReady")])]), _vm._v(" "), _c('p', [_c('span', {
    class: _vm.cd(_vm.$parent.showFormStage)
  }, [_vm._v("FORM")]), _vm._v(" - (not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.formSubmitted)
  }, [_vm._v("formSubmitted")]), _vm._v(" and not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.formFilled)
  }, [_vm._v("formFilled")]), _vm._v(" ) or not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.$data.kycSubmitted)
  }, [_vm._v("kycSubmitted")])]), _vm._v(" "), _c('p', [_c('span', {
    class: _vm.cd(_vm.$parent.showConfirmedStage)
  }, [_vm._v("CONFIRMED")]), _vm._v(" -\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.kycStatus === 'PASSED')
  }, [_vm._v("kycStatus = PASSED")]), _vm._v(" and not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.decisionFinalRejected)
  }, [_vm._v("decision rejected")])]), _vm._v(" "), _c('p', [_c('span', {
    class: _vm.cd(_vm.$parent.showPendingKYCStage)
  }, [_vm._v("KYC HIT")]), _vm._v("\n\t\t\t\t\t- "), _c('span', {
    class: _vm.cd(_vm.$parent.kycStatus)
  }, [_vm._v("kyc")]), _vm._v(" not null and not PASSED and not\n\t\t\t\t\t"), _c('span', {
    class: _vm.cd(_vm.$parent.decisionFinalRejected)
  }, [_vm._v("decision rejected")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-3",
    class: _vm.cd(_vm.$parent.showErrorStage)
  }, [_vm._v("ERROR")]), _vm._v(" "), _c('p', {
    class: _vm.cd(_vm.$parent.$data.processing)
  }, [_vm._v("LOADING")]), _vm._v(" "), _c('p', {
    class: _vm.cd(_vm.$parent.$data.finishing)
  }, [_vm._v("FINISHING")]), _vm._v(" "), _c('p', {
    class: _vm.cd(_vm.$parent.readyToSubmit)
  }, [_vm._v("\n\t\t\t\t\tREADY TO SUBMIT\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    class: _vm.cd(_vm.$parent.waitingForDecision)
  }, [_vm._v("WAITING FOR DECISION")])]) : _vm._e(), _vm._v(" "), !_vm.isMobile ? _c('p', {
    staticClass: "my-2 mt-6 text-sm font-semibold tracking-widest uppercase opacity-50"
  }, [_vm._v("\n\t\t\t\tActions\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.resetAccount
    }
  }, [_vm._v("reset account")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.getFingerprints
    }
  }, [_vm._v("get fingerprints")]), _vm._v(" "), _c('button', {
    on: {
      "click": function ($event) {
        _vm.showPurchaseMenu = true;
      }
    }
  }, [_vm._v("pixel purchase + postbacks")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.updateIdentity
    }
  }, [_vm._v("update identity")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.clearForm
    }
  }, [_vm._v("clear form")]), _vm._v(" "), _vm.$parent.$data.error || _vm.$parent.$data.errorContext ? _c('button', {
    on: {
      "click": _vm.clearError
    }
  }, [_vm._v("\n\t\t\t\tclear error\n\t\t\t")]) : _vm._e()]) : _vm.open && _vm.showPurchaseMenu ? _c('div', {
    staticClass: "menu"
  }, [_c('span', {
    staticClass: "mb-1 text-base opacity-50 cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.showPurchaseMenu = false;
      }
    }
  }, [_vm._v("← Back")]), _vm._v(" "), _c('p', {
    staticClass: "flex justify-between w-full mb-6 text-lg font-semibold"
  }, [_vm._v("\n\t\t\t\tTest pixel purchase + postbacks\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center"
  }, [_c('p', {
    staticClass: "mt-2 mb-1"
  }, [_vm._v("Client-side pixels:")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-2 text-base underline opacity-50 cursor-pointer",
    on: {
      "click": _vm.uncheckAllClient
    }
  }, [_vm._v("\n\t\t\t\t\tUnselect all\n\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "mx-2 text-base underline opacity-50 cursor-pointer",
    on: {
      "click": _vm.checkAllClient
    }
  }, [_vm._v("\n\t\t\t\t\tSelect all\n\t\t\t\t")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.facebook,
      expression: "skipPurchases.facebook"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.facebook) ? _vm._i(_vm.skipPurchases.facebook, null) > -1 : _vm._q(_vm.skipPurchases.facebook, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.facebook,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "facebook", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "facebook", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "facebook", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("Facebook + Conversions API")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.gtm,
      expression: "skipPurchases.gtm"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.gtm) ? _vm._i(_vm.skipPurchases.gtm, null) > -1 : _vm._q(_vm.skipPurchases.gtm, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.gtm,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "gtm", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "gtm", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "gtm", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("GTM")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center"
  }, [_c('p', {
    staticClass: "mt-2 mb-1"
  }, [_vm._v("Server-side postbacks:")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-2 text-base underline opacity-50 cursor-pointer",
    on: {
      "click": _vm.uncheckAllServer
    }
  }, [_vm._v("\n\t\t\t\t\tUnselect all\n\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "mx-2 text-base underline opacity-50 cursor-pointer",
    on: {
      "click": _vm.checkAllServer
    }
  }, [_vm._v("\n\t\t\t\t\tSelect all\n\t\t\t\t")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.everflow,
      expression: "skipPurchases.everflow"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.everflow) ? _vm._i(_vm.skipPurchases.everflow, null) > -1 : _vm._q(_vm.skipPurchases.everflow, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.everflow,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "everflow", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "everflow", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "everflow", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("Everflow")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.prodege,
      expression: "skipPurchases.prodege"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.prodege) ? _vm._i(_vm.skipPurchases.prodege, null) > -1 : _vm._q(_vm.skipPurchases.prodege, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.prodege,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "prodege", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "prodege", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "prodege", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("Prodege")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.tapjoy,
      expression: "skipPurchases.tapjoy"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.tapjoy) ? _vm._i(_vm.skipPurchases.tapjoy, null) > -1 : _vm._q(_vm.skipPurchases.tapjoy, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.tapjoy,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "tapjoy", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "tapjoy", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "tapjoy", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("Tapjoy")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.fintel,
      expression: "skipPurchases.fintel"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.fintel) ? _vm._i(_vm.skipPurchases.fintel, null) > -1 : _vm._q(_vm.skipPurchases.fintel, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.fintel,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "fintel", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "fintel", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "fintel", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("Fintel")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.lockerdome,
      expression: "skipPurchases.lockerdome"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.lockerdome) ? _vm._i(_vm.skipPurchases.lockerdome, null) > -1 : _vm._q(_vm.skipPurchases.lockerdome, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.lockerdome,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "lockerdome", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "lockerdome", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "lockerdome", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("Lockerdome")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.bem,
      expression: "skipPurchases.bem"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.bem) ? _vm._i(_vm.skipPurchases.bem, null) > -1 : _vm._q(_vm.skipPurchases.bem, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.bem,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "bem", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "bem", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "bem", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("BEM")])]), _vm._v(" "), _c('label', {
    staticClass: "flex flex-row items-center my-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.skipPurchases.ppm,
      expression: "skipPurchases.ppm"
    }],
    staticClass: "w-auto",
    attrs: {
      "true-value": false,
      "false-value": true,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPurchases.ppm) ? _vm._i(_vm.skipPurchases.ppm, null) > -1 : _vm._q(_vm.skipPurchases.ppm, false)
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.skipPurchases.ppm,
          $$el = $event.target,
          $$c = $$el.checked ? false : true;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.skipPurchases, "ppm", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.skipPurchases, "ppm", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.skipPurchases, "ppm", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-lg"
  }, [_vm._v("PPM")])]), _vm._v(" "), _c('button', {
    staticClass: "mt-6",
    on: {
      "click": _vm.pixelPurchase
    }
  }, [_vm._v("Send it!")])]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };